// extracted by mini-css-extract-plugin
module.exports = {"mobileRootLayout":"zFK4a"};